import React, {} from 'react';
import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "root/FallbackComponent";
import './Header.scss';
import NavigationRow from "root/Header/NavigationRow";
import { useGlobalContext } from "root/Contexts/GlobalContext";

import { TableActionIconGeneric } from "root/Tables/BaseTableComponents";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const Header = ( props ) =>
{
    const { getCustomObject, system_params, name } = useGlobalContext() ;

    const logoPath = getCustomObject( ConfigOptions.HEADER_LOGO_PATH ) ;
    const docName = getCustomObject( ConfigOptions.HEADER_NAME ) ;

    const logout = () =>
    {
        window.location.replace ( "?logout" );
    }

    return (
        <ErrorBoundary FallbackComponent={ FallbackComponent }>
            <div className='header-row-top'>
                <div className='logo'>
                    <img style={ system_params.authority_logo_path.style } src={ system_params.authority_logo_path.imagePath } alt="image"/>
                    <img style={ { height: '110px', marginLeft: 'auto', marginRight: 'auto' } }
                         src={ logoPath } alt="image"/>
                    <span ><h5>{ name }</h5>
                       <div className='logout-logo'><TableActionIconGeneric onClick={ logout }
                                                                            style={ { fontSize: '2rem' } }
                                                                            icon='bi bi-box-arrow-right' color='#3E6C93'
                                                                            text='Logout'/></div></span>
                </div>
                <div className='logo-mobile'>
                    <div>
                        <img style={ { width: '142px' } } src={ logoPath } alt="image"/></div>
                    <div className='mobile-logo'><TableActionIconGeneric onClick={ logout }
                                                                         style={ { fontSize: '2rem' } }
                                                                         icon='bi bi-box-arrow-right' color='#3E6C93'
                                                                         text='logout'/></div>
                </div>
            </div>
            <div className='header-row-next'>
                <div>{docName}</div>
            </div>
            <NavigationRow/>
        </ErrorBoundary>
    )
}

export default Header;
